/**
 * شاشة «التسجيلات» — **موقوفة على تكامل خارجي، والشاشة بتقول ده صراحةً.**
 *
 * ⛔ **ليه مش مبنية بشاشة فاضية:** التسجيلات بتيجي من زووم عبر بورتال
 *    المورّد، والملخّص التلقائي محتاج نموذج لغوي. الاتنين **مش موجودين**.
 *    شاشة فيها جداول فاضية بتخلّي مسؤولة التدريب تفتكر إن السيستم واقع أو
 *    إن مفيش حصص النهارده — وهي في الحقيقة القناة مش موصولة أصلًا.
 *
 * 🔑 والقاعدة اللي بنمشي عليها في السيستم كله: **«مش شغّال» غير «مفيش»**.
 *    نفس السبب اللي خلّى «طلبات المعلمين» ترجع `null` مش صفر.
 */
import { Shell } from "@/components/Shell";
import "@/styles/registry.css";

export function Recordings() {
  return (
    <Shell title="التسجيلات">
      <div className="reg-card" style={{ padding: 20, lineHeight: 2 }}>
        <div className="sec-title">القناة مش موصولة لسه</div>
        <p className="t-meta">
          مراجعة الحصص محتاجة حاجتين مش موجودين في السيستم دلوقتي:
        </p>
        <ul className="t-meta" style={{ paddingInlineStart: 20 }}>
          <li>
            <strong>تسجيلات زووم من بورتال المورّد</strong> — مفيش تكامل
            بيجيب الحصص ولا روابط التسجيل.
          </li>
          <li>
            <strong>الملخّص التلقائي</strong> — محتاج نموذج لغوي، ومفتاحه
            مش متحط.
          </li>
        </ul>
        <p className="t-meta">
          ⛔ وعشان كده الشاشة بتقول كده بدل ما تعرض جدولًا فاضيًا يخلّيكي
          تفتكري إن مفيش حصص النهارده.
        </p>
        <div className="sec-title" style={{ marginTop: 16 }}>لحد ما توصل</div>
        <p className="t-meta">
          سجّلي المخالفة أو الملاحظة على المعلم من{" "}
          <strong>«الإشراف الإداري» ⇒ المخالفات والمكافآت</strong> — دي
          شغّالة دلوقتي وبتتسجّل باسمك وبتروح للمدير يعتمدها.
        </p>
      </div>
    </Shell>
  );
}
